import React from 'react'
import { StaticImage } from 'gatsby-plugin-image';
import Slider from 'react-slick';
import parser from 'html-react-parser'

import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';

export default function Slider5({data}) {
    const {slider5Subtitle, slider5Title, slider5Slides, slider5BackgroundColor} = data;
    
    const settings = {
        dots: false,
        infinite: true,
        arrow: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
    };

    return (
        <div className={`global-testimonial-slider-wrap light-${slider5BackgroundColor}-bg`}>
            <div className='container sm-container'>
                <div className='row'>
                    <div className='col-md-12 global-slider-header text-center'>
                        <figure className='global-icon-image'>
                            <StaticImage src='../../../images/chat-icon.png' alt='image' />
                        </figure>
                        <h2 className='heading-level-2 blue-color'>{slider5Title && parser(slider5Title)}</h2>
                    </div>
                </div>
                <div className='row g-testimonial-slide-row slick-slider-arrow lt-rt-arrow'>
                    <div className='col-md-3'>
                        <figure className='g-testimonial-icon'>
                            <StaticImage
                                src='../../../images/testimonial-icon.png'
                                alt='image'
                            />
                        </figure>
                    </div>
                    <div className='col-md-9'>
                        <Slider {...settings}>
                            {slider5Slides?.map((block, i) => (
                                <div key={i}>
                                    <div className='testimonial-content-sec'>
                                        <p>
                                            <strong>{block.slider5SlideText && parser(block.slider5SlideText)}</strong>
                                        </p>
                                        <p>{block.slider5SlideTitle && parser(block.slider5SlideTitle)}</p>
                                    </div>
                                </div>
                            ))}
                        </Slider>
                    </div>
                </div>
            </div>
        </div>
    )
}
